import React from "react";

const UpscBooksMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      <div className="accordion" id="upscBooksAccordion">
        {/* Prelims Books */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="prelimsHeading">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#prelimsCollapse"
              aria-expanded="true"
              aria-controls="prelimsCollapse"
            >
              UPSC Prelims Books
            </button>
          </h2>
          <div
            id="prelimsCollapse"
            className="accordion-collapse collapse show"
            aria-labelledby="prelimsHeading"
            data-bs-parent="#upscBooksAccordion"
          >
            <div className="accordion-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Subject</th>
                    <th>Books</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>History</td>
                    <td>
                      India’s Struggle for Independence – Bipan Chandra
                      <br />
                      Indian Art and Culture by Nitin Singhania
                      <br />
                      NCERT XI (Ancient & Medieval), NCERT XII (Modern Indian
                      History)
                    </td>
                  </tr>
                  <tr>
                    <td>Geography</td>
                    <td>
                      Certificate Physical Geography – G C Leong
                      <br />
                      NCERT VI – X (Old Syllabus), NCERT XI, XII (New Syllabus)
                      <br />
                      World Atlas (Orient Black Swan)
                    </td>
                  </tr>
                  <tr>
                    <td>Indian Polity</td>
                    <td>
                      Indian Polity – M Laxmikanth
                      <br />
                      NCERT IX-XII
                    </td>
                  </tr>
                  <tr>
                    <td>Economics</td>
                    <td>
                      Indian Economy by Nitin Singhania
                      <br />
                      Economic Development & Policies in India – Jain & Ohri
                      <br />
                      NCERT XI
                    </td>
                  </tr>
                  <tr>
                    <td>International Relations</td>
                    <td>
                      NCERT XII (Contemporary World Politics)
                      <br />
                      Current Affairs
                    </td>
                  </tr>
                  <tr>
                    <td>CSAT</td>
                    <td>
                      Tata McGraw Hill CSAT Manual
                      <br />
                      Verbal & Non-Verbal Reasoning – R S Aggarwal
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Mains Books */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="mainsHeading">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainsCollapse"
              aria-expanded="false"
              aria-controls="mainsCollapse"
            >
              UPSC Mains Books
            </button>
          </h2>
          <div
            id="mainsCollapse"
            className="accordion-collapse collapse"
            aria-labelledby="mainsHeading"
            data-bs-parent="#upscBooksAccordion"
          >
            <div className="accordion-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Subject</th>
                    <th>Books</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>History, Indian Heritage & Culture (GS Paper 1)</td>
                    <td>
                      Indian Art and Culture by Nitin Singhania
                      <br />
                      India’s Struggle for Independence by Bipan Chandra
                      <br />
                      India after Independence by Bipan Chandra
                      <br />
                      History of Medieval India by Satish Chandra
                      <br />
                      Ancient India by R.S Sharma
                    </td>
                  </tr>
                  <tr>
                    <td>Geography (GS Paper 1)</td>
                    <td>
                      Geography of India by Majid Husain
                      <br />
                      World Geography by Majid Husain
                      <br />
                      World Atlas (Orient Black Swan)
                      <br />
                      Certificate Physical and Human Geography – G C Leong
                      <br />
                      Fundamentals of Physical Geography NCERT Class 11
                    </td>
                  </tr>
                  <tr>
                    <td>Polity & International Relations (GS Paper 2)</td>
                    <td>
                      Indian Polity by M. Laxmikanth
                      <br />
                      Introduction to the Constitution of India by DD Basu
                      <br />
                      International Relations: Pushpesh Pant
                    </td>
                  </tr>
                  <tr>
                    <td>Economy (GS Paper 3)</td>
                    <td>
                      Indian Economy – Nitin Singhania
                      <br />
                      Environment and Disaster Management – Tata McGraw Hill
                      <br />
                      Challenges to Internal Security of India – Ashok Kumar
                    </td>
                  </tr>
                  <tr>
                    <td>Ethics (GS Paper 4)</td>
                    <td>
                      Ethics, Integrity and Aptitude for Civil Services Main
                      Examination by Subba Rao and P.N. Roy Chaudary
                    </td>
                  </tr>
                  <tr>
                    <td>Solved Papers</td>
                    <td>
                      IAS General Studies Prelims Solved Papers – Vishal
                      Publications
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Study Material */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="studyMaterialHeading">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#studyMaterialCollapse"
              aria-expanded="false"
              aria-controls="studyMaterialCollapse"
            >
              Additional Study Material
            </button>
          </h2>
          <div
            id="studyMaterialCollapse"
            className="accordion-collapse collapse"
            aria-labelledby="studyMaterialHeading"
            data-bs-parent="#upscBooksAccordion"
          >
            <div className="accordion-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Study Material</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Reports</td>
                    <td>
                      2nd ARC Report <br />
                      Economic Survey (Latest) <br />
                      Budget (Latest) <br />
                      Finance Commission Report (Latest) <br />
                      Annual reports by central ministries
                    </td>
                  </tr>
                  <tr>
                    <td>Current Affairs</td>
                    <td>
                      The Hindu Newspaper <br />
                      Yojana Magazine <br />
                      Press Information Bureau Releases <br />
                      Niti Aayog Action Agenda
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpscBooksMain;
